export class User {
    constructor(userState) {
        this.userState = userState;
    }
    get id() {
        return this.userState.id;
    }
    get access_token() {
        return this.userState.access_token;
    }
    get name() {
        return this.userState.name;
    }
    get email() {
        return this.userState.email;
    }
    get date_created() {
        return this.userState.date_created;
    }
    getState() {
        return this.userState;
    }
}
